import { render } from "./TicketsChart.vue?vue&type=template&id=1f47fd66&ts=true"
import script from "./TicketsChart.vue?vue&type=script&lang=ts"
export * from "./TicketsChart.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__